<template>
  <div class="container-page">
    <template v-if="isAccessAllowed">
      <div>
        <p class="title-inner">Карточка группы ролей</p>
      </div>
      <div>
        <div class="row">
          <div class="col-12" v-if="!item.id">
            <div class="form-group required">
              <ComponentInput
                v-model="item.name"
                label="Внутреннее название"
                required
                maxLength="50"
                placeholder="Введите название группы"
                :disabled="!canEdit"
              />
            </div>
          </div>
          <div class="col-12">
            <div class="form-group required">
              <ComponentInput
                v-model="item.title"
                label="Название"
                required
                maxLength="250"
                placeholder="Введите название группы"
                :disabled="!canEdit"
              />
            </div>
          </div>
          <div class="col-12">
            <div class="form-group">
              <ComponentInput
                type="select2"
                v-model="item.childRoleIds"
                label="Роли"
                multiple
                :select2Settings="select2SettingsMultiple"
                :select2Options="roles"
                :disabled="!canEdit"
              />
            </div>
          </div>
        </div>
      </div>

      <div>
        <ButtonComponent v-if="canEdit" class="mr-8" mod="gradient-bg" @click="save"> Сохранить </ButtonComponent>
        <ButtonComponent mod="border" @click="close"> Отмена </ButtonComponent>
      </div>
    </template>
  </div>
</template>

<script>
  import { useVuelidate } from '@vuelidate/core';

  import ComponentInput from '@/common/components/ComponentInput.vue';
  import ButtonComponent from '@/common/components/redesigned/ButtonComponent.vue';
  import Constants from '@/common/constants';
  import security from '@/common/mixins/security';

  import API from '../api/roles';

  const PERMISSIONS = {
    view: Constants.Permissions.RoleView,
    create: Constants.Permissions.RoleCreate,
    edit: Constants.Permissions.RoleEdit,
  };

  export default {
    name: 'RoleGroupCard',
    components: {
      ComponentInput,
      ButtonComponent,
    },
    mixins: [security],
    data() {
      return {
        id: this.$route.params.id,
        item: {
          isGroupRole: true,
        },
        roles: [],
        select2SettingsMultiple: Constants.select2SettingsMultiple,
        canEdit: false,
      };
    },
    async created() {
      const isAllowed = await this.checkPermissionAndRedirect(PERMISSIONS.view);
      if (!isAllowed) return;

      const editPermission = Number(this.id) > 0 ? PERMISSIONS.edit : PERMISSIONS.create;
      this.checkPermission(editPermission).then((response) => {
        this.canEdit = response.data;
      });
      this.loadDictionaries();
      this.loadCard();
    },
    methods: {
      loadDictionaries() {
        API.search({ pageNumber: 1, pageSize: 0 }).then((response) => {
          this.roles = response.data.items
            .filter((x) => !x.isGroupRole && (!x.parentId || (x.parentId > 0 && x.parentId == this.id)))
            .map((x) => ({ id: x.id, text: x.title }));
        });
      },
      loadCard() {
        if (this.id > 0) {
          API.find(this.id).then((response) => {
            this.item = response.data;
            if (!this.item.isGroupRole)
              this.$router.push({ name: 'RoleCard', params: { id: this.item.id, action: 'edit' } });
          });
        } else {
          this.item = {
            isActive: true,
            organizationId: 1,
          };
        }
        this.item.isGroupRole = true;
      },
      save() {
        this.v$.$touch();
        if (this.v$.$invalid) {
          Constants.alert.fire('Ошибка', 'Проверьте правильность заполнения полей', 'error');
          return;
        }

        API.update(this.item)
          .then(() => {
            Constants.alert.fire('Сохранение', Constants.commonSuccess, 'success');
            if (this.id > 0) {
              this.loadCard();
            } else {
              this.$router.push({ name: 'Roles' });
            }
          })
          .catch((error) => {
            console.error(error?.response?.data);
            var mess = error?.response?.data ? error?.response?.data : Constants.commonError;
            mess = mess
              .replace('Role name', 'Роль с внутренним названием')
              .replace('is already taken', 'уже используется');
            Constants.alert.fire('Сохранение', mess, 'error');
          });
      },
      close() {
        this.$router.back();
      },
    },
    setup: () => ({ v$: useVuelidate() }),
    validations() {
      return {
        item: {},
      };
    },
  };
</script>

<style lang="scss" scoped></style>
